// ── imgFade — posters arrive, they don't pop ─────────────────────────────────
// Every TMDB image in the app used to appear the instant its bytes landed, which on
// a grid reads as a flicker of rectangles. Now any image from image.tmdb.org starts
// transparent and fades in on load (CSS below; .nx-ld marks "loaded"). One capture
// listener covers every <img> ever mounted; the observer handles images that were
// already complete when they mounted (cached), which never fire load again; and the
// sweep is the belt to those braces, so nothing can stay invisible. Reduced motion
// removes the transition, not the images.
const SEL = 'img[src*="image.tmdb.org"]'
const mark = (img) => { if (img && !img.classList.contains('nx-ld')) img.classList.add('nx-ld') }
export function initImgFade() {
  if (typeof document === 'undefined' || window.__nextepImgFade) return
  window.__nextepImgFade = true
  const onLoad = (e) => { if (e.target instanceof HTMLImageElement) mark(e.target) }
  document.addEventListener('load', onLoad, true)
  document.addEventListener('error', onLoad, true)   // a broken image shows its fallback, not a hole
  const settle = (root) => {
    const list = root.matches?.(SEL) ? [root] : root.querySelectorAll?.(SEL) || []
    for (const img of list) if (img.complete) mark(img)
  }
  try {
    new MutationObserver((muts) => { for (const m of muts) for (const n of m.addedNodes) if (n.nodeType === 1) settle(n) }).observe(document.body, { childList: true, subtree: true })
  } catch {}
  setInterval(() => settle(document.body), 1500)
}
